/**
 * 数据表接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TableManagementService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

   //#region 数据表接口
  /**
   * 查询数据表所有信息
   * @param param
   * @returns {Observable<any>}
   */
  queryDataTablePageList(param) {
    const url = this.prefix + 'dataTable/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 查看数据表信息
   * @param param
   * @returns {Observable<any>}
   */
  getTable(param) {
    const url = this.prefix + 'dataTable/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 更新数据表信息
   * @param param
   * @returns {Observable<any>}
   */
  updateTable(param) {
    const url = this.prefix + 'dataTable/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 删除数据表单个信息
   * @param param
   * @returns {Observable<any>}
   */
  deleteTable(param) {
    const url = this.prefix + 'dataTable/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 增加数据表单个信息
   * @param param
   * @returns {Observable<any>}
   */
  saveTable(param) {
    const url = this.prefix + 'dataTable/save';
    return this.http.Post(url, param);
  }

  //#endregion


}
